import React from 'react';
import { StyledAccordionItemGroup, AccordionItemText } from './styles.js';
import { removeTrailingSlash } from './utils.js';
import Badge from '../../Badge/Badge.js';
import '../../Text/Caption/Caption.js';
import '../../Text/DetailedSubheading/DetailedSubheading.js';
import '../../Text/OverlineLg/OverlineLg.js';
import '../../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../../Text/ParagraphLg/ParagraphLg.js';
import '../../Text/ParagraphMd/ParagraphMd.js';
import '../../Text/SectionHeading/SectionHeading.js';
import '../../Text/SectionSubheading/SectionSubheading.js';
import '../../Text/Title/Title.js';
import { StyledTooltip } from '../styles.js';

function AccordionItemContent({ onClick, Icon, name, href, badge, isSideNavExpanded, startAnimations, isSideNavVisible, }) {
    const isActive = removeTrailingSlash(window.location.pathname) === removeTrailingSlash(href);
    return (React.createElement(StyledTooltip, Object.assign({ content: name, side: "right" }, (isSideNavExpanded ? { forceOpen: false } : undefined)),
        React.createElement("li", null,
            React.createElement(StyledAccordionItemGroup, { href: href, isActive: isActive, isSideNavVisible: isSideNavVisible, isSideNavExpanded: isSideNavExpanded, "data-tracking-name": name, "data-tracking-props": { isSideNavigation: true }, tabIndex: 1, onClick: onClick }, Icon !== null && Icon !== void 0 ? Icon : null,
                React.createElement(AccordionItemText, { isSideNavExpanded: isSideNavExpanded, startAnimations: startAnimations, isSideNavVisible: isSideNavVisible },
                    React.createElement(ParagraphLg, { as: "span" }, name),
                    badge && React.createElement(Badge, { variation: badge.variation }, badge.text))))));
}

export { AccordionItemContent };
